import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';

export default function Cookiepolitik() {
  return (
    <div className="customer-legal-page">
      <Breadcrumbs 
        items={[
          { label: 'Forside', path: '/' },
          { label: 'Cookie politik' }
        ]} 
      />
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h1 className="text-4xl font-bold mb-8">Cookiepolitik</h1>
          
          <p>Senest opdateret: 19-12-2025</p>
          
          <p>Denne cookiepolitik forklarer, hvordan Enkel Energi ApS (CVR: 44925702), Bryghuspladsen 8, 1473 København K, anvender cookies og lignende teknologier på vores website.</p>
          
          <p>Når du besøger vores website første gang, bliver du bedt om at tage stilling til brugen af cookies via vores cookiebanner. Du kan til enhver tid ændre eller trække dit samtykke tilbage.</p>
          
          <h2>Hvad er cookies?</h2>
          
          <p>Cookies er små tekstfiler, som gemmes på din enhed (computer, mobil eller tablet), når du besøger et website. Cookies bruges bl.a. til at sikre teknisk funktionalitet, forbedre brugeroplevelsen, analysere trafik og vise relevante annoncer.</p>
          
          <p>Cookies kan være:</p>
          <ul>
            <li>Førstepartscookies, som sættes af vores website</li>
            <li>Tredjepartscookies, som sættes af eksterne tjenester</li>
          </ul>
          
          <h2>Hvilke typer cookies bruger vi?</h2>
          
          <p>Vi anvender følgende typer cookies:</p>
          
          <h3>1. Nødvendige cookies</h3>
          
          <p>Disse cookies er nødvendige for, at websitet fungerer korrekt og sikkert. De kan ikke fravælges i vores systemer.</p>
          
          <p>Nødvendige cookies bruges bl.a. til:</p>
          <ul>
            <li>At gemme dit cookie-samtykke</li>
            <li>At sikre grundlæggende funktioner som sidevisning, navigation og sikkerhed</li>
          </ul>
          
          <p>Disse cookies kræver ikke samtykke.</p>
          
          <h3>2. Funktionelle cookies</h3>
          
          <p>Funktionelle cookies gør det muligt at huske dine valg og præferencer, så websitet fungerer mere optimalt og personligt.</p>
          
          <p>De bruges fx til:</p>
          <ul>
            <li>At huske indstillinger og tidligere valg</li>
            <li>At sikre korrekt visning og funktion på tværs af enheder og browsere</li>
          </ul>
          
          <h3>3. Statistikcookies (Analytics)</h3>
          
          <p>Statistikcookies hjælper os med at forstå, hvordan besøgende bruger vores website, ved at indsamle oplysninger om fx besøg, trafik og adfærd.</p>
          
          <p>Vi bruger statistikcookies til:</p>
          <ul>
            <li>At analysere brugen af websitet</li>
            <li>At forbedre indhold, struktur og brugeroplevelse</li>
          </ul>
          
          <p>Oplysningerne behandles i aggregeret og anonymiseret form, hvor det er muligt.</p>
          
          <h3>4. Marketingcookies (Annoncer)</h3>
          
          <p>Marketingcookies anvendes til at vise relevante annoncer og til at måle effekten af vores markedsføring på tværs af digitale platforme.</p>
          
          <p>Disse cookies kan bl.a. bruges til:</p>
          <ul>
            <li>At vise målrettede annoncer</li>
            <li>At begrænse antallet af gange, du ser den samme annonce</li>
            <li>At måle og optimere vores annoncering</li>
          </ul>
          
          <p>Marketingcookies kan bruges af tredjepartsleverandører og kan følge din aktivitet på tværs af websites.</p>
          
          <h3>Markedsføring, analyse og kundeadministration</h3>
          
          <p>Vi kan behandle kunders almindelige kontaktoplysninger og tekniske identifikatorer (fx e-mailadresse, telefonnummer, kunde-ID og online identifikatorer) til brug for markedsføring, analyse og kundeadministration på tværs af Leverandørens systemer og kanaler.</p>
          
          <p>Oplysningerne kan anvendes til:</p>
          <ul>
            <li>målretning og visning af markedsføringsindhold på digitale kanaler</li>
            <li>måling af effekt og relevans af markedsføringsaktiviteter</li>
            <li>vedligeholdelse og anvendelse af kunde- og CRM-systemer</li>
            <li>segmentering, aggregeret analyse og statistiske formål</li>
          </ul>
          
          <p>Hvor det er relevant, behandles oplysningerne i pseudonymiseret eller aggregeret form, herunder ved brug af tekniske foranstaltninger som hashing, inden de anvendes i eksterne systemer eller platforme.</p>
          
          <p>Behandlingen sker alene på baggrund af kundens samtykke eller andet gyldigt behandlingsgrundlag efter databeskyttelsesforordningen. Kunden kan til enhver tid gøre indsigelse mod eller trække sit samtykke tilbage i overensstemmelse med gældende regler.</p>
          
          <h2>Cookieoversigt</h2>
          
          <p>Vi anvender CookieYes til at administrere cookies og dit samtykke. En opdateret og detaljeret oversigt over de konkrete cookies, herunder formål, udbyder og opbevaringsperiode, er altid tilgængelig via cookieindstillingerne på websitet.</p>
          
          <h2>Samtykke og ændring af indstillinger</h2>
          
          <p>Når du besøger vores website første gang, bliver du bedt om at give samtykke til brugen af ikke-nødvendige cookies.</p>
          
          <p>Du kan til enhver tid:</p>
          <ul>
            <li>Ændre dit samtykke</li>
            <li>Trække dit samtykke tilbage</li>
          </ul>
          
          <p>Dette gøres via cookieindstillingerne, som er tilgængelige fra vores website.</p>
          
          <h2>Opbevaringsperiode</h2>
          
          <p>Cookies gemmes i forskellige tidsrum afhængigt af deres formål. Nogle cookies slettes, når du lukker din browser, mens andre gemmes i en længere periode. Den konkrete opbevaringsperiode fremgår af cookieoversigten i CookieYes.</p>
          
          <h2>Videregivelse af oplysninger</h2>
          
          <p>Oplysninger indsamlet via cookies kan blive behandlet af tredjepartsleverandører, herunder leverandører uden for EU/EØS. I sådanne tilfælde sikrer vi, at overførslen sker i overensstemmelse med gældende databeskyttelseslovgivning, herunder via EU's standardkontraktbestemmelser.</p>
          
          <h2>Ændringer i cookiepolitikken</h2>
          
          <p>Vi forbeholder os retten til løbende at opdatere denne cookiepolitik. Den seneste version vil altid være tilgængelig på vores website.</p>
          
          <div className="mt-12 pt-8 border-t">
            <h3 className="text-2xl font-bold mb-4">Har du spørgsmål?</h3>
            <p>Kontakt os gerne på <a href="mailto:hej@enkelenergi.dk" className="text-[#ffdc3e] hover:underline">hej@enkelenergi.dk</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}